import { intervalToDuration, formatDuration } from 'date-fns';
import _ from '@lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextField, InputAdornment } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

function EditFormUptimeField(props) {
	const methods = useFormContext();
	const { t } = useTranslation(props.config.topic ? ['editform', props.config.topic] : 'editform');
	const { value } = props.field;
	const [textValue, setTextValue] = useState('');
	const [readOnly, setReadOnly] = useState(true);

	useEffect(() => {
		const updateValue = () => {
			const currentTime = new Date().getTime();
			if (!_.isUndefined(value) && value !== null && value >= 0 && value < currentTime) {
				setTextValue(formatDuration(
					intervalToDuration({ 
						start: new Date(currentTime - value), 
						end: new Date(currentTime) 
					})
				));
			} else {
				setTextValue('');
			}
		};

		updateValue();
		
		// Only update every second if there's a valid value
		let interval;
		if (value !== null && value >= 0) {
			interval = setInterval(updateValue, 1000);
		}

		return () => {
			if (interval) {
				clearInterval(interval);
			}
		};
	}, [value]); // Only depend on value changes

	return (
		<TextField
			{...props.field}
			value={textValue}
			onChange={e => setTextValue(e.target.value)}
			className={clsx('mt-8 mb-16', props.fieldConfig.className)}
			label={!_.isUndefined(props.fieldConfig.text) ? props.fieldConfig.text : t(`${props.config.topic}:${props.fieldConfig.key}`)}
			id={props.field.name}
			variant="outlined"
			fullWidth
			multiline={props.fieldConfig.multiline || false}
			autoComplete={props.fieldConfig.autoComplete || 'on'}
			InputProps={{
				maxLength: props.fieldConfig.maxLength || null,
				readOnly,
				startAdornment: props.fieldConfig.startAdornment,
				endAdornment: readOnly ? (
					<InputAdornment position="end">
						<Lock fontSize="small" color="disabled" />
					</InputAdornment>
				) : (
					props.fieldConfig.endAdornment
				)
			}}
		/>
	);
}

export default EditFormUptimeField;
